export const Role = {
    Tutor: "Tutor",
    User: "User",
}